import template from './lease-type.jade';
import leaseType from '../../../enums/lease-type';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.leaseType', [])
    .directive('cianAfPriceAndDealTermsLeaseType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.leaseTypes = leaseType;

            this.validation = validation(this.form, 'bargainTerms.leaseType', {
                required: 'Укажите тип аренды',
            });
        },
        controllerAs: 'leaseType',
        template,
    }))
    .name;
